import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Pagination } from "../../../../../common/entity/Entity";
import { RootState } from "../../../../../store";
import { TodoCode, TodoTaskItem, TodoTaskList } from "../../entity/Entity";
import { ServiceImpl } from "../../usecase/ServiceImpl";

const Handler = (service: ServiceImpl) => {
    const todoCategoryList = useSelector(
        (state: RootState) => state.todoTaskWorkflow.todoCategoryList
    );
    const [params, setParam] = useSearchParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [todoTaskList, setTodoTaskList] = useState<TodoTaskList>([]);
    const [pagination, setPagination] = useState<Pagination | null>(null);

    const categoryIdSelected = params.get("categoryId");

    const getTodoListByCategory = async (params: any) => {
        setLoading(true);
        const todoList = await service.getTodoListByCategory(params);
        setTodoTaskList(todoList.results);
        setPagination(todoList.pagination);
        setLoading(false);
    };

    const getProjectDetails = async (projectId: number) => {
        setLoading(true);
        const params = {
            projectId,
        };
        const res = await service.getProjectById(params);
        setLoading(false);
        return res
    };

    const handleRedirectScreen = async (item: TodoTaskItem) => {
        switch (item.type.code) {
            case TodoCode.TodoTaskCIWaitingSubmit:
            case TodoCode.TodoTaskCIWaitingApprove:
            case TodoCode.TodoTaskCIReject: {
                const projectDetails = await getProjectDetails(item.project.id);
                navigate(
                    `/app-ci001/${item.project.id}/${item.construction.id}/0/${projectDetails?.results?.projectManager?.id}?projectName=${item.project.name}`
                );
                break;
            }
            case TodoCode.TodoTaskCRWaitingSubmit:
            case TodoCode.TodoTaskCRWaitingApprove:
            case TodoCode.TodoTaskCRReject: {
                const projectDetails = await getProjectDetails(item.project.id);
                navigate(
                    `/app-cr003/${item.project.id}/${item.construction.id}/0/${projectDetails?.results?.projectManager?.id}?projectName=${item.project.name}`
                );
                break;
            }
            case TodoCode.TodoTaskCRNotInvite: {
                const projectDetails = await getProjectDetails(item.project.id);
                navigate(
                    `/app-cr003/${item.project.id}/${item.construction.id}/0/${projectDetails?.results?.projectManager?.id}?projectName=${item.project.name}&tab=2`
                );
                break;
            }
            case TodoCode.TodoTaskMemberInvite: {
                navigate(`/app-pm005/${item.project.id}`, {
                    state: {
                        action: TodoCode.TodoTaskMemberInvite,
                        constructionId: item.construction?.id || 0,
                    }
                });
                break;
            }
            case TodoCode.TodoTaskProjectMemberWaitingApprove: {
                navigate(`/app-pm005/${item.project.id}`, {
                    state: {
                        action: TodoCode.TodoTaskProjectMemberWaitingApprove,
                        constructionId: item.construction?.id || 0,
                        colabConstructionId: item.colabConstruction?.id || 0
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    };

    const onClickTodo = (item: TodoTaskItem) => {
        handleRedirectScreen(item);
    };

    const toggleSortType = () => {
        const currentSortType = params.get("sortBy") || "newest";
        if (currentSortType === "newest") {
            params.set("sortBy", "oldest");
            setParam(params);
        } else {
            params.set("sortBy", "newest");
            setParam(params);
        }
    };

    const checkCategorySelected = (
        currentCategory: number,
        categoryIdSelected: string | null
    ) => {
        // Case view all
        if (!categoryIdSelected) return currentCategory === -1;
        // Other cases
        return currentCategory === +categoryIdSelected;
    };

    const onSelectCategory = (id: number) => {
        if (id !== -1) {
            params.set("categoryId", `${id}`);
            setParam(params);
            return;
        }
        // Select view all
        params.delete("categoryId");
        setParam(params);
    };

    const setPageSize = (val: number) => {
        params.set("size", val.toString());
        params.set("page", "1");
        setParam(params);
    };

    const setPageNumber = (val: number) => {
        params.set("page", val.toString());
        setParam(params);
    };

    return {
        todoCategoryList,
        getTodoListByCategory,
        todoTaskList,
        pagination,
        categoryIdSelected,
        checkCategorySelected,
        onSelectCategory,
        isLoadingList: loading,
        toggleSortType,
        setPageSize,
        setPageNumber,
        onClickTodo,
    };
};

export default Handler;
